import React from 'react';
import img from '../../Images/heros.png'

const About = () => {
    return (
        <section className='py-5'>

            <h2 className='text-center pb-5'>This is about page</h2>

        </section>
    );
};

export default About;